import { HrAsAServicePage } from 'components/marketingSite/hrAsAService';
import { SuccessCasesProps } from 'components/marketingSite/hrAsAService/sections/successCases/SuccessCases.types';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type HelpingCompaniesPageProps = {
  baseUrl?: string;
};

const parseJSON = (resp: any) => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any) => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const HrAsAService: React.FC<HelpingCompaniesPageProps & SuccessCasesProps> = ({
  baseUrl,
  items
}) => {
  const { t } = useI18n('hr-as-a-service');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        title={t('hr-as-a-service.page_title')}
        url={APP_URLS.hrAsAService}
        desc={t('hr-as-a-service.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_hr_as_a_service.png'
        )}`}
        indexable={true}
      />

      <HrAsAServicePage items={items} />
    </>
  );
};

export default HrAsAService;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const items = await fetch(
    `https://cms.getmanfred.com/api/consultancy-success-cases?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
    {
      headers,
      method: 'GET'
    }
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(({ data }) => {
      return data.sort((a: any, b: any) => {
        return a.attributes.order < b.attributes.order ? -1 : 1;
      });
    });

  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'hr-as-a-service'
      ])),
      baseUrl: config.appUrl,
      items
    },
    revalidate: 30
  };
};
